import React from 'react';
import { Phone, Mail, MapPin, Globe } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a3a5c] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4">Phone</h4>
            <a href="tel:+18555827843" className="text-gray-300 hover:text-white block mb-1">
              1.855.PROF.IMM
            </a>
            <a href="tel:+15617991883" className="text-gray-300 hover:text-white block">
              +001.561.799.1883
            </a>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Email</h4>
            <a href="mailto:info@profimmigration.com" className="text-gray-300 hover:text-white">
              info@profimmigration.com
            </a>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Address</h4>
            <p className="text-gray-300">
              691 North U.S. Highway 1<br />
              Tequesta, FL 33469
            </p>
          </div>
        </div>

        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="flex items-center space-x-3">
            <Globe className="w-12 h-12 text-white" strokeWidth={1.5} />
            <div className="text-center">
              <span className="block text-lg font-semibold">US PROFESSIONAL</span>
              <span className="block text-sm">IMMIGRATION</span>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="flex justify-center space-x-4 mb-8">
          {['facebook', 'twitter', 'linkedin', 'instagram'].map((social) => (
            <a
              key={social}
              href={`#${social}`}
              className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
            >
              <span className="sr-only">{social}</span>
              <div className="w-4 h-4 bg-white/60 rounded-full"></div>
            </a>
          ))}
        </div>

        {/* Copyright */}
        <div className="text-center text-gray-400 text-sm border-t border-white/10 pt-8">
          <p>
            © {new Date().getFullYear()} US Professional Immigration. All rights reserved. Call +001.561.799.1883.
            <a href="#privacy" className="hover:text-white ml-2">View our Privacy Policy.</a>
          </p>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 text-center">
          <button className="text-gray-400 text-sm hover:text-white underline">
            Disclaimer
          </button>
        </div>

        <div className="mt-4 text-gray-500 text-xs leading-relaxed max-w-4xl mx-auto">
          <p>
            <strong>Disclaimer:</strong> This website provides immigration consulting services and is not affiliated with any government agency. All information is for general informational purposes only and does not constitute legal advice. No offer to sell or solicitation may be made until proper documentation has been provided. Past performance is no guarantee of future results.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
